var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.55222 0.901222C6.73607 0.531194 7.26393 0.531195 7.44778 0.901223L8.94927 3.92323C9.02208 4.06976 9.16197 4.1714 9.32383 4.19536L12.6619 4.68951C13.0706 4.75002 13.2338 5.25204 12.9387 5.54123L10.5285 7.90309C10.4117 8.01761 10.3582 8.18207 10.3855 8.34341L10.947 11.6708C11.0158 12.0782 10.5887 12.3885 10.2225 12.1972L7.23149 10.6349C7.08646 10.5592 6.91354 10.5592 6.76851 10.6349L3.77749 12.1972C3.41125 12.3885 2.98421 12.0782 3.05297 11.6708L3.61453 8.34341C3.64176 8.18207 3.58832 8.01761 3.47146 7.90309L1.06135 5.54123C0.766242 5.25204 0.929358 4.75002 1.33809 4.68951L4.67617 4.19536C4.83803 4.1714 4.97792 4.06976 5.05073 3.92323L6.55222 0.901222Z",
    fill: "#F1C83A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_973_491",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55222 0.901222C6.73607 0.531194 7.26393 0.531195 7.44778 0.901223L8.94927 3.92323C9.02208 4.06976 9.16197 4.1714 9.32383 4.19536L12.6619 4.68951C13.0706 4.75002 13.2338 5.25204 12.9387 5.54123L10.5285 7.90309C10.4117 8.01761 10.3582 8.18207 10.3855 8.34341L10.947 11.6708C11.0158 12.0782 10.5887 12.3885 10.2225 12.1972L7.23149 10.6349C7.08646 10.5592 6.91354 10.5592 6.76851 10.6349L3.77749 12.1972C3.41125 12.3885 2.98421 12.0782 3.05297 11.6708L3.61453 8.34341C3.64176 8.18207 3.58832 8.01761 3.47146 7.90309L1.06135 5.54123C0.766242 5.25204 0.929358 4.75002 1.33809 4.68951L4.67617 4.19536C4.83803 4.1714 4.97792 4.06976 5.05073 3.92323L6.55222 0.901222Z",
    fill: "#F1C83A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_973_491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29102 10.7917C5.42435 5.89175 6.51324 1.75008 7.29102 0.291748L0.582682 4.08341L0.291016 8.75008L3.49935 14.8751C5.44366 15.5556 9.15768 15.6917 7.29102 10.7917Z",
    fill: "#EDB017"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5a93e6527de4e5f98cfc44ba8c5e9f78.svg";
export { ForwardRef as ReactComponent };